<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate"
                >Invitaciones - OOTT {{ data.idOOTT }}</span
            >
            <button
                style="float: right"
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        <app-listado-invitaciones-contratistas
            [idOOTT]="data.idOOTT"
            [puedeAsignar]="data.puedeAsignar"
        ></app-listado-invitaciones-contratistas>
    </mat-dialog-content>
    <mat-divider></mat-divider>
    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-button mat-dialog-close>Cerrar</button>
    </mat-dialog-actions>
</div>
